import { FailureKind } from '@sb/routine-runner/FailureKind';
import type { StepPlayArguments } from '@sb/routine-runner/Step/Step';
import Step from '@sb/routine-runner/Step/Step';

import { CNCOperateAutodoorArguments } from './Arguments';
import { CNCOperateAutodoorVariables } from './Variables';

export class CNCOperateAutodoorStep extends Step<
  CNCOperateAutodoorArguments,
  CNCOperateAutodoorVariables
> {
  public static areSubstepsRequired = false;

  public static Arguments = CNCOperateAutodoorArguments;

  public static Variables = CNCOperateAutodoorVariables;

  public initializeVariableState(): void {
    this.variables = {};
  }

  public async _play({ fail }: StepPlayArguments): Promise<void> {
    try {
      await this.routineContext.equipment.executeCommand({
        kind: 'CNCMachineCommand',
        deviceID: this.args.deviceID,
        subCommand: {
          kind: 'autodoor',
          actionID: this.args.actionID,
        },
      });
    } catch (error) {
      fail({
        failure: { kind: FailureKind.HaasFailure },
        failureReason: 'Autodoor action failed',
        error,
      });
    }
  }
}
